"use client";

import React, { useState, useEffect, useContext, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter, notFound } from "next/navigation";

import SocketContext from "@/socket/Context";
import styles from "./video.module.scss";
import services from "@/store/services";
import Components from "@/components";
import apis from "@/api";

function VideoDashContent({ children, slug }) {
  const { certificate, preEnroll, postEnroll, notes } = useSelector(
    (state) => state.tours
  );
  const { courseInfo, isEnrolled } = useSelector((state) => state.video);
  const enrollments = useSelector((state) => state.enrollment);
  const { socket } = useContext(SocketContext).SocketState;
  const user = useSelector((state) => state?.user?.users);

  const [showError, setShowError] = useState(false);

  const dispatch = useDispatch();
  const router = useRouter();

  const fetchCourse = useCallback(async () => {
    if (!slug) return;
    try {
      const res = await apis.getcourseV2(slug);
      if (res.status !== 200) setShowError(true);
      else {
        const isRestricted = res.data?.result?.visibility === "restricted";
        const isEnrolled = user?.email
          ? enrollments.length > 0 &&
            enrollments.find((x) => x.courseId === res.data?.result?._id)
          : false;
        const isCreator = res.data.result.creatorInfo[0]._id === user?._id;
        if (isRestricted && !isEnrolled && !isCreator) {
          // notFound();
          setShowError(true);
        } else
          dispatch(
            services.updateCourseInfo({
              courseInfo: res.data?.result,
              isEnrolled,
              isRestricted,
            })
          );
      }
    } catch (error) {
      setShowError(true);
      // notFound();
    }
  }, [user, router]);

  const videoCompleteCheck = useCallback(() => {
    socket?.on("course:videoComplete", (res) => {
      if (res.courseId === courseInfo?._id && res.userId === user._id) {
        dispatch(services.fetchEnrollment());
      }
    });

    return () => {
      socket?.off("course:videoComplete");
    };
  }, [socket]);

  useEffect(() => {
    if (showError) notFound();
  }, [showError]);

  useEffect(() => {
    fetchCourse();
  }, [fetchCourse]);

  useEffect(() => {
    videoCompleteCheck();
  }, [videoCompleteCheck]);

  return (
    <section className={styles["video-content"]}>
      {certificate &&
      isEnrolled?.certificate?.status ===
        process.env.NEXT_PUBLIC_CERTIFICATE_PENDING_STATUS ? (
        <Components.Tour
          stepsData={Components.CERTIFICATE_TOUR_DATA}
          tourFor="certificate"
        />
      ) : null}
      {preEnroll ? (
        <Components.Tour
          stepsData={Components.PRE_ENROLLMENT_TOUR_DATA}
          tourFor="pre"
        />
      ) : null}
      {postEnroll ? (
        <Components.Tour
          stepsData={Components.POST_ENROLLMENT_TOUR_DATA}
          tourFor="post"
        />
      ) : null}
      {notes ? (
        <Components.Tour
          stepsData={Components.NOTES_TOUR_DATA}
          tourFor="notes"
        />
      ) : null}
      <div className={styles["player-side"]}>{children}</div>
      <Components.VideoSidebar />
    </section>
  );
}

export default VideoDashContent;
